import { useState } from 'react';

interface Testimonial {
  name: string;
  role: string;
  company: string;
  content: string;
  avatar: string;
  rating: number;
}

const testimonials: Testimonial[] = [
  {
    name: '田中 健一',
    role: '代表取締役',
    company: '田中商事株式会社',
    content: '長年探していた理想の住まいを見つけることができました。担当者の方の丁寧な対応と専門的なアドバイスに大変感謝しております。物件の選定から契約まで、全てのプロセスにおいて信頼できるサポートをいただきました。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businessman%20in%20his%20fifties%20wearing%20navy%20suit%20and%20glasses%20with%20salt%20and%20pepper%20hair%2C%20confident%20executive%20portrait%2C%20neutral%20gray%20background%2C%20corporate%20headshot%20photography%20style%2C%20sharp%20focus%2C%20professional%20lighting&width=200&height=200&seq=avatar-tanaka-v2&orientation=squarish',
    rating: 5
  },
  {
    name: '佐藤 美咲',
    role: '経営企画部長',
    company: 'グローバルテック株式会社',
    content: '売却から購入まで、全てのプロセスをスムーズに進めていただきました。信頼できるパートナーとして、今後もお付き合いをお願いしたいと思います。市場分析も的確で、最適なタイミングでの取引ができました。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businesswoman%20in%20her%20thirties%20with%20long%20straight%20black%20hair%20wearing%20cream%20colored%20blazer%2C%20friendly%20smile%2C%20neutral%20background%2C%20corporate%20portrait%20photography%2C%20natural%20lighting%2C%20professional%20headshot&width=200&height=200&seq=avatar-sato-v2&orientation=squarish',
    rating: 5
  },
  {
    name: '山田 誠',
    role: '投資部門責任者',
    company: '山田ホールディングス',
    content: '資産運用の観点から的確なアドバイスをいただき、満足のいく投資ができました。プロフェッショナルな対応に感謝しております。長期的な視点での提案が特に印象的でした。',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Japanese%20businessman%20with%20receding%20hairline%20wearing%20dark%20pinstripe%20suit%20and%20burgundy%20tie%2C%20serious%20professional%20expression%2C%20gray%20background%2C%20executive%20portrait%20photography%2C%20studio%20lighting&width=200&height=200&seq=avatar-yamada-v2&orientation=squarish',
    rating: 5
  },
  {
    name: '鈴木 恵子',
    role: '取締役',
    company: '鈴木不動産開発',
    content: '初めての不動産購入で不安でしたが、丁寧な説明と細やかな配慮で安心して契約することができました。アフターフォローも充実しており、大変満足しております。',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20businesswoman%20in%20her%20early%20forties%20with%20shoulder-length%20layered%20hair%2C%20wearing%20burgundy%20blazer%20and%20delicate%20gold%20necklace%2C%20warm%20professional%20smile%2C%20corporate%20headshot%20photography%2C%20light%20gray%20background%2C%20sophisticated%20business%20portrait&width=400&height=400&seq=testimonial-avatar-004-v2&orientation=squarish',
    rating: 5
  },
  {
    name: '高橋 大輔',
    role: 'マーケティング部長',
    company: 'デジタルソリューションズ株式会社',
    content: '都心の一等地で理想的な物件を見つけることができました。市場動向の分析から価格交渉まで、プロフェッショナルなサポートをいただき、期待以上の結果となりました。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Japanese%20professional%20man%20in%20his%20thirties%20with%20modern%20undercut%20hairstyle%20wearing%20charcoal%20gray%20suit%20and%20white%20shirt%2C%20confident%20expression%2C%20light%20background%2C%20contemporary%20business%20portrait%2C%20professional%20photography&width=200&height=200&seq=avatar-takahashi-v2&orientation=squarish',
    rating: 5
  },
  {
    name: '伊藤 由美',
    role: '財務責任者',
    company: '伊藤コンサルティング',
    content: '複数の物件を比較検討する際、それぞれの特徴を分かりやすく説明していただきました。投資価値の観点からも納得のいく選択ができ、大変感謝しております。',
    avatar: 'https://readdy.ai/api/search-image?query=Sophisticated%20Japanese%20businesswoman%20with%20wavy%20shoulder%20length%20hair%20wearing%20statement%20pearl%20earrings%20and%20navy%20blazer%2C%20professional%20smile%2C%20neutral%20background%2C%20executive%20portrait%20photography%2C%20elegant%20lighting&width=200&height=200&seq=avatar-ito-v2&orientation=squarish',
    rating: 5
  }
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section id="testimonials" className="py-28 bg-[#FAFAFA]">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-20">
          <p
            className="text-[13px] tracking-[0.2em] text-[#666666] mb-6 font-medium"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            TESTIMONIALS
          </p>
          <h3
            className="text-[36px] leading-tight font-bold text-[#1A1A1A] mb-4"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            お客様の声
          </h3>
          <p
            className="text-[15px] text-[#666666] leading-relaxed"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            信頼いただいているお客様から多くのお声をいただいております
          </p>
        </div>

        <div className="relative">
          {/* Main Featured Testimonial */}
          <div className="bg-white rounded-2xl p-12 shadow-sm border border-[#E5E5E5] mb-8">
            <div className="flex items-start gap-8">
              <div className="flex-shrink-0">
                <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-[#E5E5E5]">
                  <img
                    src={testimonials[activeIndex].avatar}
                    alt={testimonials[activeIndex].name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-4">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#D4AF37] text-lg"></i>
                  ))}
                </div>
                
                <p
                  className="text-[16px] leading-[1.9] text-[#333333] mb-8"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {testimonials[activeIndex].content}
                </p>
                
                <div className="flex items-center justify-between pt-6 border-t border-[#E5E5E5]">
                  <div>
                    <h4
                      className="text-[18px] font-semibold text-[#1A1A1A] mb-1"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {testimonials[activeIndex].name}
                    </h4>
                    <p
                      className="text-[13px] text-[#666666]"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {testimonials[activeIndex].role} / {testimonials[activeIndex].company}
                    </p>
                  </div>
                  
                  <div className="flex items-center gap-3">
                    <button
                      onClick={() => setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1))}
                      className="w-11 h-11 rounded-full border border-[#E5E5E5] flex items-center justify-center hover:bg-[#F5F5F5] transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-left-s-line text-xl text-[#333333]"></i>
                    </button>
                    <button
                      onClick={() => setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1))}
                      className="w-11 h-11 rounded-full border border-[#E5E5E5] flex items-center justify-center hover:bg-[#F5F5F5] transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-right-s-line text-xl text-[#333333]"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Thumbnail Grid */}
          <div className="grid grid-cols-6 gap-4">
            {testimonials.map((testimonial, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`group relative rounded-xl overflow-hidden border-2 transition-all cursor-pointer ${
                  activeIndex === index
                    ? 'border-[#1A2B3C] shadow-md'
                    : 'border-transparent hover:border-[#E5E5E5]'
                }`}
              >
                <div className="aspect-square">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                  <div
                    className={`absolute inset-0 transition-opacity ${
                      activeIndex === index ? 'bg-black/0' : 'bg-black/20 group-hover:bg-black/10'
                    }`}
                  ></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <p
                    className="text-[11px] text-white font-medium truncate"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {testimonial.name}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-3 gap-8 mt-20 pt-16 border-t border-[#E5E5E5]">
          <div className="text-center">
            <div
              className="text-[48px] font-bold text-[#1A2B3C] mb-2"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              1,200+
            </div>
            <p
              className="text-[14px] text-[#666666]"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              取引実績件数
            </p>
          </div>
          <div className="text-center">
            <div
              className="text-[48px] font-bold text-[#1A2B3C] mb-2"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              98%
            </div>
            <p
              className="text-[14px] text-[#666666]"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              顧客満足度
            </p>
          </div>
          <div className="text-center">
            <div
              className="text-[48px] font-bold text-[#1A2B3C] mb-2"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              25年
            </div>
            <p
              className="text-[14px] text-[#666666]"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              業界経験年数
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
